// extracted by mini-css-extract-plugin
module.exports = {"link":"ColumnLink_link__h4P50"};